import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=79524edd&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79524edd')) {
      api.createRecord('79524edd', component.options)
    } else {
      api.reload('79524edd', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=79524edd&", function () {
      api.rerender('79524edd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4HDnQ7pWvh0SR/JS/pricehelp.vue"
export default component.exports